import React from 'react';

import { AuthProvider } from '@propelauth/react';
import { PostHogProvider } from 'posthog-js/react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { isDemoZone } from './components/demo/constants';
import reportWebVitals from './reportWebVitals';
import posthog from './services/analytics/posthog';
import { initFaroWithRouter } from './services/faro/faroRouter';
import { installStaleChunkGuard } from './utils/lazyWithReload';
import 'reset-css';
import './services/sentry';

// Recover from stale-bundle chunk failures after a new deploy (see lazyWithReload).
installStaleChunkGuard();

initFaroWithRouter();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (!process.env.REACT_APP_AUTH_URL) {
  throw new Error('REACT_APP_AUTH_URL environment variable is not set');
}

const appTree = (
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);

root.render(
  <React.StrictMode>
    {/* Demo zone authenticates with the demo cookie — don't mount PropelAuth at
        all, so it never fires token/refresh calls. */}
    {isDemoZone ? (
      appTree
    ) : (
      <AuthProvider authUrl={process.env.REACT_APP_AUTH_URL}>{appTree}</AuthProvider>
    )}
  </React.StrictMode>
);

reportWebVitals();
